module.exports = __webpack_public_path__ + "img/chinesecompany52.a22ab480.png";